import api from './axiosService';

export const stockApi = {
    getAll(params = {}) {
        return api.get('/stocks', { params });
    },

    getMyShops(params = {}) {
        return api.get('/stocks/my-shops', { params });
    },

    getById(stockId) {
        return api.get(`/stocks/${stockId}`);
    },

    getByShop(shopId) {
        return api.get(`/stocks/shop/${shopId}`);
    },

    getAvailableForSale(shopId) {
        return api.get(`/stocks/shop/${shopId}/available-for-sale`);
    },

    getMyShopsAvailableForSale() {
    return api.get('/stocks/my-shops/available-for-sale');
},

    getTotalByShop(shopId) {
        return api.get(`/stocks/shop/${shopId}/total`);
    },

    getWithSales(stockId) {
        return api.get(`/stocks/${stockId}/with-sales`);
    },

    getByDateRange(params = {}) {
        return api.get('/stocks/by-date-range', { params });
    },

    create(data) {
        return api.post('/stocks', data);
    },

    update(stockId, data) {
        return api.put(`/stocks/${stockId}`, data);
    },

    toggleStatus(stockId) {
        return api.patch(`/stocks/${stockId}/toggle-status`);
    },
};
